<template>
<div class="event-download" v-if="!isMobile && docFile.length > 0">
    <event-detail-title :type="anchorMap.DOWNLOAD_KEY"></event-detail-title>
    <div class="download-container">
    <div class="card-box" v-for="(item, index) in docFile" :key="index">
      <div class="top">
        <event-detail-download-icon :type="item.type"></event-detail-download-icon>
        <div class="info">
          <div class="title">{{item.res_name | sliceTitle}}</div>
          <span class="size">{{getFileSize(item.size, 0)}}</span>
        </div>
      </div>
      <div class="bottom">
        <a class="download" download :href="item.url" >下载</a>
        <!-- <span class="download" @click="download(item.url, item.res_name)">下载</span> -->
        <div class="iconfont icon-download icon-size"></div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
import VueTypes from 'vue-types'
import axios from 'axios'
import eventDetailTitle from './event-detail-title'
import eventDetailDownloadIcon from './event-detail-download-icon'
import { getFileSize, anchorMap, anchorData, DATA_TYPE } from './utils'
export default {
  name: 'event-detail-download',
  components: {
    eventDetailDownloadIcon,
    eventDetailTitle
  },
  props: {
    res: VueTypes.array.def([])
  },
  data () {
    return {
      anchorMap,
      anchorData
    }
  },
  filters: {
    /**
     * title 名称默认只显示一行半.
     * 计算过程：(单行文本宽度 150 + 半行文本宽度 75) / (font-size 16)
     */
    sliceTitle: function (value) {
      const length = (150 + 75) / 16
      if (value.length > length) {
        return value.slice(0, length) + '...'
      } else {
        return value
      }
    }
  },
  computed: {
    ...mapState({
      isMobile: 'isMobile'
    }),
    docFile () {
      const types = [DATA_TYPE.get('ppt'), DATA_TYPE.get('word'), DATA_TYPE.get('video')]
      return this.res?.filter(item => types.includes(item.type)) || []
    }
  },
  methods: {
    download (url, fileName = '资料') {
      axios.get(url, { responseType: 'blob' }).then(blob => {
        const link = window.URL.createObjectURL(blob.data)
        const a = document.createElement('a')
        a.href = link
        a.download = fileName
        a.click()
      })
    },
    getFileSize
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/bulma/app.sass';

.download-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .card-box {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    width: 240px; height: 115px;
    padding-top: 16px;
    margin-right: 27.5px;
    margin-bottom: 15px;
    background: #F5F7FA;
    border-radius: 4px;

    &:nth-child(3n) {
      margin-right: 0;
    }

    .top{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%; height: 48px;
      padding: 0 20px;
      margin-bottom: 16px;

      .info {
        position: relative;
        height: 48px;
        .title{
          width: 150px;
          line-height: 24px;
          font-size: 16px; font-weight: 400; color: #353535;
        }

        .size {
          position: absolute; right: 2px;top: 29.6px;
          line-height: 18px;
          font-size: 12px; font-weight: 400; color: #B2B2B2;
        }
      }

    }

    .bottom {
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1;
      width: 100%;
      border-top: 1px solid #FFF;
      cursor: pointer;

      .download {
        margin-right: 10px;
        line-height: 14px;
        font-size: 14px; font-weight: 400; color: #353535;
      }

      .icon-size {
        font-size: 14px;
      }

      &:hover{
        color: #D7B375;

        .download {
          color: #D7B375;
        }
      }
    }
  }
}
</style>
